import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Grid,
  Divider,
  TextField,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { useFormRCAutoDetails } from "../rcautoContext";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../redux/slices/snackbar";
import { validations } from "../../profile/validations";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../../config";

const PopoverPagaARate = ({ open, onClose, dataPrev }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { formState } = useFormRCAutoDetails();
  const { cliente } = formState || {};
  console.log(formState);

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  // Extract contact info
  const emailObj =
    cliente?.contatti?.find(
      (c) => c.idTipologia === 3 && c.predefinito === 1,
    ) || cliente?.contatti?.find((c) => c.idTipologia === 3);

  const phoneObj =
    cliente?.contatti?.find(
      (c) => c.idTipologia === 1 && c.predefinito === 1,
    ) ||
    cliente?.contatti?.find(
      (c) => c.idTipologia === 2 && c.predefinito === 1,
    ) ||
    cliente?.contatti?.find((c) => c.idTipologia === 1) ||
    cliente?.contatti?.find((c) => c.idTipologia === 2);

  const nome = cliente?.nome || "";
  const cognome = cliente?.cognome || "";
  const cf = cliente?.cf || "";
  const [email, setEmail] = useState(emailObj?.valore || "");
  const [telefono, setTelefono] = useState(phoneObj?.valore || "");

  const handleNext = () => {
    setStep(2);
  };

  const handleBack = () => {
    setStep(1);
  };

  const handleClose = () => {
    setStep(1);
    setIsSuccess(false);
    setIsFailed(false);
    onClose();
  };

  const handleProcedi = async () => {
    setLoading(true);
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          totalProductsPrice: String(dataPrev?.dettagli.prezzoPreventivo),
          customerEmail: email,
          customerName: nome,
          customerSurname: cognome,
          customerContactNumber: telefono,
          products: [
            {
              sku: "xyz12345",
              name: "Polizze RCA",
              price: dataPrev?.prezzoTotale,
              quantity: 1,
            },
          ],
          token: dataPrev?.idUID,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/heylight/payments/v1/init`,
        requestOptions,
      );

      setLoading(false);

      console.log(response);
      const responseData = await response.json();

      if (responseData.success === true) {
        setIsSuccess(true);
      } else {
        setIsFailed(true);
      }
    } catch (error) {
      console.error("Errore durante la chiamata all'API esterna:", error);
      setIsFailed(true);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : handleClose}
      fullWidth
      maxWidth="sm"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
            borderRadius: "12px",
            padding: "8px",
          },
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>
        {isSuccess
          ? "Operazione completata"
          : isFailed
          ? "Errore durante il pagamento"
          : step === 1
          ? "Verifica Dati Cliente"
          : "Requisiti per il Pagamento"}
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ mt: 2 }}>
        {loading ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={4}
            gap={2}
          >
            <CircularProgress color="primary" />
            <Typography variant="body1" color="textSecondary">
              Connessione all'API esterna in corso...
            </Typography>
          </Box>
        ) : isSuccess ? (
          <Box>
            <Typography variant="h6" sx={{ mb: 2, lineHeight: 1.6 }}>
              Riceverai una email con il link per completare il pagamento a rate
              tramite la piattaforma esterna.
            </Typography>
          </Box>
        ) : isFailed ? (
          <Box>
            <Typography variant="h6" sx={{ mb: 2, lineHeight: 1.6 }}>
              Si è verificato un errore durante il pagamento. Riprova più tardi.
            </Typography>
          </Box>
        ) : step === 1 ? (
          <Box>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: "medium" }}>
              Controllare la correttezza dei dati:
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Nome */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pb: 1,
                }}
              >
                <Typography variant="body1" color="textSecondary">
                  Nome
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {nome || "-"}
                </Typography>
              </Box>

              {/* Cognome */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pb: 1,
                }}
              >
                <Typography variant="body1" color="textSecondary">
                  Cognome
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {cognome || "-"}
                </Typography>
              </Box>

              {/* Codice Fiscale */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pb: 1,
                }}
              >
                <Typography variant="body1" color="textSecondary">
                  Codice Fiscale
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {cf || "-"}
                </Typography>
              </Box>

              {/* Email */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pb: 1,
                }}
              >
                <Typography variant="body1" color="textSecondary">
                  Email
                </Typography>
                <TextField
                  sx={{ width: "50%" }}
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={
                    Boolean(email === "") ||
                    !validations.Email.regex.test(email)
                  }
                  helperText={
                    email === "" || !validations.Email.regex.test(email)
                      ? "Errore email"
                      : ""
                  }
                />
              </Box>

              {/* Telefono */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pb: 1,
                }}
              >
                <Typography variant="body1" color="textSecondary">
                  Telefono
                </Typography>
                <TextField
                  sx={{ width: "50%" }}
                  name="telefono"
                  value={telefono}
                  onChange={(e) => setTelefono(e.target.value)}
                  error={
                    Boolean(telefono === "") ||
                    !validations.Telefono.regex.test(telefono)
                  }
                  helperText={
                    telefono === "" ||
                    !validations.Telefono.regex.test(telefono)
                      ? "Errore numero di telefono"
                      : ""
                  }
                />
              </Box>
            </Box>
          </Box>
        ) : step === 2 ? (
          <Box>
            <Typography variant="h6" sx={{ mb: 2, lineHeight: 1.6 }}>
              Per proseguire, il cliente avrà bisogno di:
            </Typography>
            <Box
              sx={{
                backgroundColor:
                  theme.palette.mode === "dark" ? "#233044" : "#fff",
                p: 2,
                borderRadius: "8px",
                border: `1px solid ${theme.palette.divider}`,
              }}
            >
              <Typography variant="h6" sx={{ lineHeight: 1.7 }}>
                • <strong>Smartphone</strong> con fotocamera
              </Typography>
              <Typography variant="h6" sx={{ lineHeight: 1.7, mt: 1 }}>
                • <strong>IBAN</strong> (conto corrente) o{" "}
                <strong>carta di credito / debito</strong>
              </Typography>
              <Typography variant="h6" sx={{ lineHeight: 1.7, mt: 1 }}>
                • <strong>Documento di identità</strong> (carta d'identità,
                patente o passaporto)
              </Typography>
            </Box>
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 1 }}>
        {!loading && (
          <>
            {isSuccess || isFailed ? (
              <Button onClick={handleClose} variant="contained" color="primary">
                Chiudi
              </Button>
            ) : step === 1 ? (
              <>
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  color="inherit"
                >
                  Chiudi
                </Button>
                <Button
                  onClick={handleNext}
                  variant="contained"
                  color="primary"
                >
                  Avanti
                </Button>
              </>
            ) : (
              <>
                <Button onClick={handleBack} variant="outlined" color="primary">
                  Indietro
                </Button>
                <Button
                  onClick={handleProcedi}
                  variant="contained"
                  color="primary"
                >
                  Procedi
                </Button>
              </>
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PopoverPagaARate;
